var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3563 9.52553C13.5444 9.03327 13.2247 8.51489 12.7176 8.39315C12.2106 8.27149 11.71 8.59493 11.4973 9.0768C11.1563 9.8496 10.6279 10.5289 9.95522 11.0479C9.03062 11.7613 7.89044 12.1279 6.72887 12.0852C5.56739 12.0426 4.45636 11.5933 3.5852 10.814C2.71403 10.0346 2.13662 8.97345 1.95132 7.8112C1.76602 6.64905 1.98431 5.45766 2.56899 4.44019C3.15368 3.42272 4.06858 2.64206 5.15781 2.23125C6.24702 1.82043 7.4432 1.80487 8.54247 2.18721C9.34229 2.46539 10.0548 2.94169 10.6188 3.56645C10.6929 3.64855 10.7769 3.71988 10.8676 3.77876L9.02495 5.35805L14 6.28546L13.9205 1.16222L12.2678 2.57867C12.2601 2.56827 12.2521 2.55797 12.2438 2.54779C11.4357 1.5547 10.3686 0.801398 9.1554 0.379441C7.64313 -0.146511 5.99773 -0.125103 4.49932 0.440022C3.00094 1.00516 1.74239 2.07903 0.938091 3.47869C0.133782 4.87835 -0.166495 6.5172 0.0884017 8.11597C0.343299 9.71474 1.13761 11.1745 2.336 12.2466C3.53438 13.3187 5.06268 13.9367 6.66055 13.9954C8.25831 14.054 9.82684 13.5498 11.0987 12.5684C12.1191 11.7811 12.8979 10.7258 13.3563 9.52553Z",
    fill: "#242424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewIcon);
export default __webpack_public_path__ + "static/media/renewIcon.d73b1d89a73adaab4b7e880c18302bfa.svg";
export { ForwardRef as ReactComponent };